import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/site';

const IMG_1 = 'https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20scene%20with%20shattered%20glass%20effect%20and%20smartphone%20screen%20displaying%20scandal%20headlines%2C%20dark%20moody%20atmosphere%20with%20red%20and%20black%20tones%2C%20editorial%20photography%20style%20with%20intense%20lighting%20and%20deep%20shadows%2C%20cinematic%20composition%2C%20mysterious%20and%20urgent%20mood&width=800&height=500&seq=hot-article-01&orientation=landscape';
const IMG_2 = 'https://readdy.ai/api/search-image?query=Leaked%20chat%20messages%20concept%20with%20glowing%20smartphone%20screens%20in%20dark%20room%2C%20redacted%20text%20overlays%2C%20mysterious%20hacker%20aesthetic%20with%20digital%20glitch%20effects%2C%20moody%20lighting%20with%20blue%20and%20red%20tones%2C%20cinematic%20cyber%20thriller%20atmosphere&width=400&height=300&seq=hot-article-02&orientation=landscape';
const IMG_3 = 'https://readdy.ai/api/search-image?query=Two-face%20contrast%20concept%20with%20elegant%20restaurant%20facade%20on%20one%20side%20and%20messy%20back%20kitchen%20on%20the%20other%2C%20split%20composition%2C%20dramatic%20lighting%20revealing%20hidden%20truth%2C%20editorial%20photography%20with%20warm%20gold%20and%20dark%20shadow%20tones%2C%20storytelling%20visual&width=400&height=300&seq=hot-article-03&orientation=landscape';
const IMG_4 = 'https://readdy.ai/api/search-image?query=Esports%20competition%20scene%20with%20dramatic%20stadium%20lighting%2C%20referee%20whistle%20and%20red%20card%20visual%20metaphor%2C%20shocked%20spectator%20reactions%2C%20high%20contrast%20dramatic%20sports%20photography%20style%20with%20intense%20spotlight%20effects&width=400&height=300&seq=hot-article-04&orientation=landscape';
const IMG_5 = 'https://readdy.ai/api/search-image?query=TV%20production%20studio%20behind%20the%20scenes%20with%20script%20papers%20scattered%20on%20floor%2C%20spotlight%20revealing%20hidden%20crew%20members%2C%20dramatic%20theatrical%20lighting%20with%20warm%20stage%20lights%20and%20dark%20backstage%20shadows%2C%20documentary%20photography%20style&width=400&height=300&seq=hot-article-05&orientation=landscape';
const IMG_6 = 'https://readdy.ai/api/search-image?query=Live%20streaming%20setup%20with%20shocked%20streamer%20expression%2C%20broken%20product%20packaging%20on%20desk%2C%20dramatic%20red%20alert%20lighting%2C%20chaotic%20studio%20scene%20with%20equipment%20falling%2C%20intense%20editorial%20photography%20with%20high%20contrast%20shadows&width=400&height=300&seq=hot-article-06&orientation=landscape';

const articleImages: Record<number, string> = { 1: IMG_1, 2: IMG_2, 3: IMG_3, 4: IMG_4, 5: IMG_5, 6: IMG_6 };

function getImageUrl(id: number): string {
  return articleImages[id] || IMG_1;
}

export default function FeaturedGrid() {
  const featured = hotArticles.slice(0, 6);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600 uppercase tracking-wide mb-2">
              <i className="ri-fire-line"></i> 热门爆料
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">
              🔥 今日最劲爆
            </h2>
          </div>
          <Link
            to="/category/51chigua"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group relative overflow-hidden rounded-lg bg-background-100 hover:bg-background-200/70 transition-all ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative ${idx === 0 ? 'h-72 md:h-full min-h-[400px]' : 'h-48'}`}>
                <img
                  src={getImageUrl(article.id)}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                <div className="absolute top-3 left-3 flex gap-2 flex-wrap">
                  <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-primary-500 text-white whitespace-nowrap">
                    {article.category}
                  </span>
                  {article.isNew && (
                    <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-accent-500 text-white whitespace-nowrap">
                      NEW
                    </span>
                  )}
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className={`font-heading font-bold text-white leading-tight mb-2 ${
                    idx === 0 ? 'text-lg md:text-2xl' : 'text-base md:text-lg'
                  }`}>
                    {article.title}
                  </h3>
                  {idx === 0 && (
                    <p className="text-white/70 text-sm mb-3 line-clamp-2">
                      {article.excerpt}
                    </p>
                  )}
                  <div className="flex items-center gap-4 text-white/50 text-xs flex-wrap">
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-chat-3-line"></i> {article.comments.toLocaleString()}
                    </span>
                    <span className="whitespace-nowrap">{article.date}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="sm:hidden mt-6 text-center">
          <Link
            to="/category/51chigua"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-semibold whitespace-nowrap"
          >
            查看全部爆料 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}